/**
 * 账号管理页面 
 */

<template>
    <div id="accountManagement">
        <add-account :addModal="addModal" @close='closeModal' @reflash='reflash'>添加账号</add-account>
        <amgn-table ref="table" @addAccount='addAcount'></amgn-table>
    </div>
   
</template>

<script>
import amgnTable from './amgnTable.vue'
import addAccount from './addAccount.vue'
import ajax from '@/lib/ajax'

export default {
    components:{
        amgnTable,
        addAccount
    },
    data(){
        return{
            addModal:false,
            ifCity:false,
            disabled:true,
            search:{
                district:'',
                platform:''
            },
            districts:[],
        }
    },
    methods:{
        addAcount(){
            this.addModal=true;
        },
        closeModal(){
            this.addModal=false;
        },
        // searchData(){
        //     this.$refs.table.getData(1,this.search)
        // },
        reflash(){
            this.$refs.table.reflash();
        },
        async getDistricts(){
            let rep = await ajax.get("/api/services/app/CLDistrict/GetList");
            if(rep.data.success){
                this.districts=rep.data.result.items;
            }
        },
        exportData(){
            this.$refs.table.exportData();
        }
    },
    created(){
        this.getDistricts();
    },
    
}
</script>


<style lang="less">
    // #accountManagement{
    //     .ivu-btn{
    //         margin:0 10px 10px 0px;
    //     }
    // }
    #search{
        margin-bottom: 10px;
    }
</style>


